import { t } from "@web-monorepo/i18n/macro";
import { DDSHeadlineText, DDSIconButton } from "@web-monorepo/dds";
import { IconX } from "@web-monorepo/dds-icons";
import { TranslatedString } from "@web-monorepo/translation-runtime";
import { clsx } from "clsx";
import React from "react";
import type { AppPageVariant } from "./AppPage";
import styles from "./AppRemoteCard.module.css";

type AppRemoteCardProps = React.PropsWithChildren<{
  /**
   * Pod identifier — drives the tile background color. Only meaningful when
   * `icon` is also passed (since the tile only renders when there's an icon
   * to fill it).
   */
  variant?: AppPageVariant;
  onRequestHide?: VoidFunction;
  title?: TranslatedString;
  icon?: string;
  className?: string;
}>;

const AppRemoteCard = ({ variant, onRequestHide, title, icon, className, children }: AppRemoteCardProps) => {
  return (
    <div className={clsx(styles.card, variant && styles[variant], className)}>
      <header className={styles.header}>
        {icon && (
          <div className={styles.headerIcon}>
            <div className={styles.tile}>
              <img src={icon} className={styles.icon} alt="" />
            </div>
          </div>
        )}
        <DDSHeadlineText as="h1" className={styles.title}>
          {title}
        </DDSHeadlineText>
        {onRequestHide && (
          <DDSIconButton
            data-name="app_remote_card:close"
            aria-label={t`Close`}
            tooltip={{ content: t`Close`, dataName: "app_remote_card:close:tooltip" }}
            variant="transparent"
            className={styles.closeButton}
            onClick={onRequestHide}
          >
            <IconX />
          </DDSIconButton>
        )}
      </header>
      {children}
    </div>
  );
};

export default AppRemoteCard;
